import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=682033bd&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682033bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('682033bd')) {
      api.createRecord('682033bd', component.options)
    } else {
      api.reload('682033bd', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=682033bd&scoped=true&", function () {
      api.rerender('682033bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ZXIQf7zW9EWH/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports